var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-image-fader`]},[_vm._l((_vm.imageData),function(image,index){return [_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.currentIndex),expression:"index === currentIndex"}],key:index,attrs:{"src":image.src}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }